document.addEventListener('DOMContentLoaded', function () {
    const cssUrl = window.__CONTACT_FORM_CSS_URL__;

    function injectCSS() {
        const el = document.querySelector('shopify-forms-embed');

        if (!el?.shadowRoot) {
            setTimeout(injectCSS, 200);
            return;
        }

        if (!cssUrl) return;

        if (el.shadowRoot.querySelector('style[data-contact-form-css]')) {
            return;
        }

        fetch(cssUrl, { cache: 'no-cache' })
            .then(res => res.text())
            .then(css => {
                const style = document.createElement('style');
                style.setAttribute('data-contact-form-css', '');
                style.textContent = css;
                el.shadowRoot.appendChild(style);
            })
            .catch(() => {});
    }

    injectCSS();
});

// Initialize Password Gate for protected pages and sections
window.initPasswordGate = function(gateId, cookie, correct) {
    const inEditor = !!(window.Shopify && window.Shopify.designMode);

    const getC = n => document.cookie.match(new RegExp(`(?:^|; )${n}=([^;]*)`))?.[1];
    const setC = (n, d) => document.cookie = `${n}=1; expires=${new Date(Date.now() + d * 864e5).toUTCString()}; path=/; SameSite=Lax`;
    const remC = n => document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    const unlock = () => {
        document.getElementById(`${gateId}-lock`)?.remove();
        const gate = document.getElementById(gateId);
        if (gate) gate.style.display = 'none';
    };

    const check = () => {
        const inp = document.getElementById(`${gateId}-input`);
        const err = document.getElementById(`${gateId}-error`);
        if (!inp) return;

        if (inp.value === correct) {
            err.style.display = 'none';
            if (!inEditor) setC(cookie, 1);
            unlock();
        } else {
            err.style.display = 'block';
            inp.value = '';
            inp.focus();
        }
    };

    document.getElementById(`${gateId}-btn`)?.addEventListener('click', check);
    document.getElementById(`${gateId}-input`)?.addEventListener('keydown', e => e.key === 'Enter' && check());

    if (inEditor) remC(cookie);
    else if (getC(cookie) === '1') unlock();
};